import React, { useEffect, useState } from 'react';

import "./Home_Import.scss"
import heroBG from "../../assets/images/landing page/hero/hero-bg.png";
import aboutUs1 from "../../assets/images/landing page/desktop-about.png";
import aboutUs2 from "../../assets/images/landing page/analytic-about.jpg";
import aboutUsShape1 from "../../assets/images/landing page/about/shape-1.png";
import aboutUsShape2 from "../../assets/images/landing page/about/shape-2.png";
import feature2 from "../../assets/images/landing page/chatbot-tara-front.png";
import gamification from "../../assets/images/gamification.png";
import feature3 from "../../assets/images/landing page/mobile chatbot-portrait.png";
import offerIcon1 from "../../assets/images/landing page/icon/01.svg";
import offerIcon2 from "../../assets/images/landing page/icon/02.svg";
import offerIcon3 from "../../assets/images/landing page/icon/03.svg";
import meetTaraImg from "../../assets/images/landing page/meeting.jpg";
import lastShapeBg from "../../assets/images/landing page/cta/bg.png";
import bgBackground from "../../assets/images/landing page/bg-shape.png";
import heroBgImage from "../../assets/images/banner-1.jpg";
import logoImg from "../../assets/images/TSCTI_logo-light.png";
import logoImgDark from "../../assets/images/TSCTI_logo-dark.png";
import videoHeroSection from "../../assets/video/landing-video.mp4";
interface FAQItem {
  question: string;
  answer: string;
}

const MyTaraLanding = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
 
    import("./home_main.css");

  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const fallback = setTimeout(() => {
      setIsLoading(false);
    }, 500);
      setIsLoading(false);

    return () => clearTimeout(fallback);
  }, []);
  const isDisabled =true
  const offers = [
    {
      delay: ".3s",
      icon: offerIcon1,
      title: "Analyze Medical Reports",
      text: "Automatically scan and interpret complex diagnostic data. Our AI identifies key health markers to provide a clear understanding of your medical standing instantly."
    },
    {
      delay: ".5s",
      icon: offerIcon2,
      title: "AI Care Summaries",
      text: "Get concise, easy-to-read summaries of your doctor visits and lab results. Tara distills long medical documents into actionable health insights for better recovery."
    },
    {
      delay: ".7s",
      icon: offerIcon3,
      title: "Manage Family Records",
      text: "Keep your entire family’s health history organized in one secure portal. Access prescriptions, vaccination logs, and past reports for every family member with a single click."
    }
  ];

  const hostingFeatures = [
    {
      delay: ".5s",
      iconClass: "fa-solid fa-video",
      title: "Integrated Video Calls",
      description: "High-definition, secure video conferencing designed for clinical consultations."
    },
    {
      delay: ".7s",
      iconClass: "fa-solid fa-stethoscope",
      title: "Real-time Patient Chat",
      description: "Instant messaging to stay connected with patients and provide immediate guidance."
    },
    {
      delay: ".9s",
      iconClass: "fa-solid fa-file-prescription",
      title: "Digital Prescriptions",
      description: "Generate and share secure digital prescriptions instantly during or after consultations."
    }
  ];

  const [activeIndex, setActiveIndex] = useState<number | null>(3);

  const faqData: FAQItem[] = [
    {
      question: "How secure is myTara with sensitive hospital data?",
      answer: "Security is our top priority. myTara uses enterprise-grade end-to-end encryption and is fully compliant with healthcare data protection standards, ensuring that patient records and hospital data remain private and protected."
    },
    {
      question: "Can Tara AI handle complex medical triage?",
      answer: "Yes, Tara is trained on extensive medical datasets to assist with symptom summarization and initial triage. However, it is designed to act as a support tool for healthcare professionals, not a replacement for clinical judgment."
    },
    {
      question: "How long does it take to implement myTara in a hospital?",
      answer: "Our cloud-based architecture allows for rapid deployment. A standard hospital setup, including staff onboarding and data migration, typically takes between 7 to 14 days depending on the institution's size."
    },
    {
      question: "Does the software support integration with existing lab equipment?",
      answer: "myTara is built with a flexible API-first approach, allowing seamless integration with most modern diagnostic equipment and laboratory information systems to centralize all your patient data in one dashboard."
    }
  ];

  const toggleAccordion = (index: number): void => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index));
  };

  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="legacy-scope-wrapper">
      {/* <header
        className="header-1 sticky"
      >
        <div className="container-fluid">
          <div className="header-main style-1">
            <div className="logo">
              <a href="/" className="header-logo">
                <img src={logoImgDark} alt="logo-img" />
              </a>
            </div>
            <div className="header-right d-flex justify-content-end align-items-center">
              <a href="/login" className="pp-login-btn me-3">
                Login
              </a>
              <a href="/register" className="pp-theme-btn">
                Register Now
              </a>
              <div className="header__hamburger d-xl-none my-auto">
                <div className="sidebar__toggle">
                  <div className="header-bar style-1">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header> */}
      <header className="custom-site-header">
  <div className="main-nav-wrapper">
    <div className="brand-logo-area">
      <a href="/">
        <img src={logoImgDark} alt="logo" />
      </a>
    </div>

    <div className="action-buttons-group">
      <a href="/login" className="auth-link-login">
        Login
      </a>
      <a href="/register" className="auth-link-register">
        Register Now
      </a>
      
      {/* Mobile Hamburger */}
      <div className="mobile-menu-trigger">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</header>
      <section className="pp-hero-section pp-hero-1 fix">
        <div className="hero-bg-image-wrapper">
          <img src={heroBgImage} alt="background" className="hero-custom-bg" />
          <div className="hero-bg-overlay"></div>
        </div>
        <div className="top-shape">
          <img src={heroBG} alt="img" />
        </div>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="pp-hero-content">
                <h1
                  className="wow img-custom-anim-left"
                  data-wow-duration="1.3s"
                  data-wow-delay="0.3s"
                >
                  {/* Meet Tara: <br /> The Intelligent Core of Hospital Efficiency */}
                  Meet Tara: The Intelligent Core of Hospital Efficiency
                </h1>

                <p className="wow fadeInUp" data-wow-delay=".5s">
                  Revolutionize your healthcare facility with an AI-driven ecosystem designed to streamline workflows, enhance patient care, and eliminate administrative bottlenecks.
                  Tara isn't just software; it's the digital heartbeat of your modern hospital.
                </p>

                <div className="pp-hero-button">
                  <a
                    href="/register"
                    className="pp-theme-btn wow fadeInUp"
                    data-wow-delay=".3s"
                  >
                    Get Started Now <i className="fa-solid fa-arrow-right-long"></i>
                  </a>
                  <a
                    href="#"
                    className="pp-theme-btn pp-style-2 wow fadeInUp"
                    data-wow-delay=".3s"
                    style={{
                      pointerEvents: isDisabled ? "none" : "auto",
                      opacity: isDisabled ? 0.5 : 1,
                      cursor: isDisabled ? "not-allowed" : "pointer",
                    }}
                    onClick={(e) => {
                      if (isDisabled) {
                        e.preventDefault();
                        return;
                      }

                    }}
                  >
                    Learn More <i className="fa-solid fa-arrow-right-long"></i>
                  </a>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-12">
              <div
                className="pp-hero-video-wrapper wow img-custom-anim-bottom"
                data-wow-duration="1.3s"
                data-wow-delay="0.3s"
              >
                <video
                  autoPlay
                  muted
                  loop
                  playsInline
                  poster="/assets/img/home-1/hero/hero-poster.jpg"
                  className="pp-hero-video"
                  preload="metadata"
                  onLoadedData={() => setIsLoading(false)}
                >
                  <source src={videoHeroSection} type="video/mp4" />
                </video>
                <div className="video-overlay"></div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <section className="pp-about-section section-padding-about fix">
        <div className="container">
          <div className="pp-about-wrapper">
            <div className="row g-4">
              <div className="col-lg-6">
                <div className="about-image">
                  <img
                    src={aboutUs1}
                    alt="img"
                    className="wow img-custom-anim-left"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.3s"
                  />
                  <div className="about-image-2">
                    <img src={aboutUs2} alt="img" />
                  </div>
                  <div className="about-shape">
                    <img src={aboutUsShape1} alt="img" />
                  </div>
                  <div className="circle-shape">
                    <img src={aboutUsShape2} alt="img" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-content">
                  <div className="pp-section-title mb-0">
                    <span className="pp-sub-title wow fadeInUp">ABOUT MYTARA</span>
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">
                      Empowering Every Hospital with a Unified Digital Core
                    </h2>
                  </div>

                  <p className="pp-text wow fadeInUp" data-wow-delay=".5s">
                    At myTara, we are redefining how healthcare institutions operate in the digital age.
                    Our mission is to provide every hospital with a sophisticated, yet intuitive, software ecosystem that serves as its intelligent core.
                    By seamlessly integrating patient onboarding, real-time vital tracking, and AI-driven triage, we eliminate the burden of manual administration.
                    We empower doctors and nursing staff to step away from paperwork and focus on what truly matters: providing exceptional patient care with data-driven precision.
                  </p>
                  {/* 
                  <div className="about-count-item wow fadeInUp" data-wow-delay=".3s">
                    <div className="count-text">
                      <h2><span className="pp-count">200</span>k+</h2>
                      <p>Businesses worldwide</p>
                    </div>
                    <div className="count-text">
                      <h2><span className="pp-count">205</span>x</h2>
                      <p>More ROI</p>
                    </div>
                    <div className="count-text">
                      <h2><span className="pp-count">2.5</span>k</h2>
                      <p>Generated on average</p>
                    </div>
                  </div> */}
                  {/* 
                  <a
                    href="/about"
                    className="pp-theme-btn wow fadeInUp"
                    data-wow-delay=".5s"
                  >
                    Discover More <i className="fa-solid fa-arrow-right-long"></i>
                  </a> */}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="pp-key-feature-section with-bg section-padding pb-0 fix">
        <div className="container section-padding-bottom">
          <div className="pp-key-feature-wrapper">
            <div className="row g-4">

              {/* Left Side: Animated Images */}
              <div className="col-lg-6">
                <div className="pp-key-feature-content">
                  <div className="pp-section-title mb-0">
                    <span className="pp-sub-title wow fadeInUp">meet Tara</span>
                    <h2 className="wow fadeInUp" data-wow-delay=".3s">
                      Your Intelligent AI Health Assistant
                    </h2>
                  </div>

                  <p className="pp-text wow fadeInUp" data-wow-delay=".5s">
                    A comprehensive medical and hospital management companion.
                  </p>

                  <ul className="pp-feature-list wow fadeInUp" data-wow-delay=".3s">
                    <li>
                      AI-powered insights for quicker medical decision-making.
                    </li>
                    <li>
                      Automated, 24/7 support to handle common patient queries instantly.
                    </li>
                    <li>
                      Smart data tracking to identify patterns in patient recovery and vitals.
                    </li>
                    <li>
                      Doctors can dictate notes directly into the system, saving precious time.
                    </li>
                  </ul>

                  {/* <a
                    href="/about"
                    className="pp-theme-btn wow fadeInUp"
                    data-wow-delay=".5s"
                  >
                    Read More <i className="fa-solid fa-arrow-right-long"></i>
                  </a> */}
                </div>
              </div>

              {/* Right Side: Content and Feature List */}
              <div className="col-lg-6">
                <div className="pp-key-feature-image">
                  <img src={feature2} alt="img" />
                  <div className="pp-key-feature-image-3 float-bob-y">
                    <img src={feature3} alt="img" />
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="pp-offer-section section-padding fix section-bg">
        <div className="container">
          <div className="pp-section-title text-center">
            <span className="pp-sub-title wow fadeInUp">
              AI Diagnostic Hub
              <span className="pp-style-2"></span>
            </span>
            <h2 className="wow fadeInUp" data-wow-delay=".3s">
              Tara bot analyzes reports, giving users smart insights
            </h2>
          </div>

          <div className="row">
            {offers.map((item, index) => (
              <div
                key={index}
                className="col-xl-4 col-lg-6 col-md-6 wow fadeInUp"
                data-wow-delay={item.delay}
              >
                <div className="pp-offer-box-item">
                  <div className="pp-offer-icon">
                    <img src={item.icon} alt="icon" />
                  </div>
                  <div className="pp-offer-content">
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
      <section className="hosting section-padding fix">
        <div className="container">

          {/* Section Header */}
          <div className="pp-section-title text-center">
            <span className="pp-sub-title pp-style-border wow fadeInUp">Doctor & Telehealth Experience</span>
            <h2 className="wow fadeInUp" data-wow-delay=".3s">
              Seamless Telehealth and <br /> Patient Engagement for Doctors
            </h2>
          </div>

          <div className="pp-hosting-wrapper">
            <div className="row g-4">

              {/* Left Side: Hosting Features List */}
              <div className="col-lg-6">
                <div className="hosting-content">
                  {hostingFeatures.map((item, index) => (
                    <div
                      key={index}
                      className="hosting-items wow fadeInUp"
                      data-wow-delay={item.delay}
                    >
                      <div className="icon">
                        <i className={item.iconClass}></i>
                      </div>
                      <div className="content">
                        <h4>{item.title}</h4>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Right Side: Secure Data Image */}
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                <div className="hosting-image">
                  <img src={meetTaraImg} alt="secure data" />
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <section className="faq-section section-bg section-padding fix">
        <div className="container">
          <div className="pp-section-title text-center">
            <span className="pp-sub-title wow fadeInUp">
              People Also Ask
              <span className="pp-style-2"></span>
            </span>
            <h2 className="wow fadeInUp" data-wow-delay=".3s">
              Frequently Asked Questions
            </h2>
          </div>
          <div className="faq-wrapper">
            {faqData.map((item: FAQItem, index: number) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                onClick={() => toggleAccordion(index)}
              >
                <div className="faq-header">
                  <h5 className={activeIndex === index ? 'text-theme' : ''}>
                    {item.question}
                  </h5>

                  <span className="faq-icon">
                    <i
                      className={`fa-solid ${activeIndex === index ? 'fa-eye-slash' : 'fa-eye'
                        }`}
                    ></i>
                  </span>
                </div>

                {/* ALWAYS RENDER */}
                <div className="faq-body">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="pp-cta-section section-padding-last fix theme-bg">
        <div className="top-shape">
          <img src={lastShapeBg} alt="background shape" />
        </div>
        <div className="container">
          <div className="pp-cta-wrapper">
            <div className="row g-4 align-items-center">

              <div className="col-lg-6">
                <div className="pp-cta-image">
                  <img
                    src={gamification}
                    alt="cta main"
                    className="wow img-custom-anim-top"
                    data-wow-duration="1.3s"
                    data-wow-delay="0.3s"
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="pp-cta-content">
                  <h2 className="wow fadeInUp" data-wow-delay=".3s">
                    Boost Hospital Productivity with myTara Rewards
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay=".5s">
                    Gamify your healthcare workflow to drive excellence.
                    Earn Tara Coins for every milestone—from onboarding patients to completing care plans on time.
                    Level up your staff's performance, track achievement history, and transform daily tasks into a
                    rewarding journey toward better patient outcomes.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>
      <footer className="pp-footer-section section-bg-2">
        {/* Top Decorative Shape */}
        <div className="top-shape">
          <img src={bgBackground} alt="footer shape" />
        </div>

        <div className="container">
          <div className="pp-footer-widget-wrapper">
            <div className="row justify-content-center">

              {/* Widget 1: Logo & Socials */}
              <div className="col-xl-12 col-lg-12 col-md-12 wow fadeInUp" data-wow-delay=".2s">
                <div className="pp-footer-widget-items">
                  {/* <div className="pp-widget-head">
                    <a href="/" className="pp-footer-logo">
                      <h5>MyTara</h5>
                    </a>
                  </div> */}
                  <div className="pp-footer-content text-center">
                    <a href="/" className="pp-footer-logo">
                      <img src={logoImg} alt="white logo" />
                    </a>
                    <p className="mt-5">
                      At myTara, we are redefining how healthcare institutions operate in the digital age. Our mission is to provide every hospital with a sophisticated, yet intuitive, software ecosystem that serves as its intelligent core.
                      By seamlessly integrating patient onboarding, real-time vital tracking, and AI-driven triage, we eliminate the burden of manual administration. We empower doctors and nursing staff to step away from paperwork and
                      focus on what truly matters: providing exceptional patient care with data-driven precision.
                    </p>
                    <div className="mt-4 pt-3 border-top" style={{ borderColor: 'rgba(255,255,255,0.15)' }}>
                      <p className="disclaimer-text">
                        <span className="fw-bold text-white-50 text-danger">Disclaimer:</span> myTara is a digital assistance platform designed for educational and operational efficiency purposes only.
                        Our AI-driven insights, symptom analysis, and vitals tracking are not substitutes for professional medical advice, diagnosis, or treatment.
                        Users should not rely solely on this information for medication changes or clinical decisions. Always consult a licensed healthcare professional
                        for medical concerns. Results are dependent on user-provided data and may be subject to inaccuracies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom3">
          <div className="container">
            <div className="pp-footer-bottom-wrapper">
              <p className="wow fadeInUp" data-wow-delay=".3s">
                Copyright© 2026 <b>MyTara</b>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MyTaraLanding;